import { render, staticRenderFns } from "./AmetrasInfoLabelFieldTemplate.vue?vue&type=template&id=47c75d44&scoped=true&"
import script from "./AmetrasInfoLabelFieldTemplate.vue?vue&type=script&lang=ts&"
export * from "./AmetrasInfoLabelFieldTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./AmetrasInfoLabelFieldTemplate.vue?vue&type=style&index=0&id=47c75d44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c75d44",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
